import axios from "axios";

let base_url;

if (process.env.NODE_ENV === "development") {
  base_url=process.env.VUE_APP_API_BASE_TEST_URL
}
else {
  base_url=process.env.VUE_APP_API_BASE_URL
}

export const API = axios.create({
  baseURL: base_url,
  headers: {
    Accept: "*/*",
  },
});

// Function to set the Authorization token
function setAuthToken(id) {
  API.defaults.headers.common["Authorization"] = `Bearer ${id}`;
  // APITest.defaults.headers.common["Authorization"] = `Bearer ${id}`;
}

// Function to fetch price favorites
const fetchPriceFavorites = async () => {
  try {
    const response = await API.get("price-favorites");
    return response.data;
  } catch (error) {
    console.error("Error fetching price favorites:", error);
    throw error;
  }
};

// Function to update price favorites
const updatePriceFavorites = async (selectedCoins) => {
  try {
    await API.put("price-favorites", selectedCoins);
    // console.log("Price favorites updated successfully");
  } catch (error) {
    console.error("Error updating price favorites:", error);
    throw error;
  }
};


// Function to get retri invite link default
const getLinkDefault = async () => {
  try {
    const response = await API.get("retri/recommend-link/default");
    return response.data;
  } catch (error) {
    console.error("Error get default link", error);
    throw error;
  }
};

// Function to get retri invite link right
const getLinkRight = async () => {
  try {
    const response = await API.get("retri/recommend-link/right");
    return response.data;
  } catch (error) {
    console.error("Error get right link", error);
    throw error;
  }
};

// Function to get retri invite link left
const getLinkLeft = async () => {
  try {
    const response = await API.get("retri/recommend-link/left");
    return response.data;
  } catch (error) {
    console.error("Error get left link", error);
    throw error;
  }
};

// Function to get retri invite link left
const getPaymentInfo = async () => {
  try {
    const response = await API.get("member/payment");
    return response.data;
  } catch (error) {
    console.error("Error getting payment info: ", error);
    throw error;
  }
};

// 임의 권한
export const chkUserPermission = async () => {
  try {
    const response = await API.get("retri/permissions");
    return response.data;
  } catch (error) {
    console.error("Error checking forcing user:", error);
    throw error;
  }
};

// 구독일자 확인 (재구매 확인)
const chkSubscribe = async () => {
  try {
    const response = await API.get("retri/subscribe");
    return response;
  } catch (error) {
    console.error("Error fetching user permission:", error);
    throw error;
  }
};


// 앱 사용자 언어 백엔드로 전달 함수 
const chkUserLang = async (lang) => {
  try {
    let language = { "deviceLanguage": lang }
    let url = `member/device-language`
    // console.log('language', language)
    const response = await API.patch(url, language);
    return response;
  } catch (error) {
    console.error("Error fetching user language:", error);
    throw error;
  }
};


export default {
  setAuthToken,
  fetchPriceFavorites,
  updatePriceFavorites,
  getLinkDefault,
  getLinkRight,
  getLinkLeft,
  getPaymentInfo,
  chkUserPermission,
  chkSubscribe,
  chkUserLang
};
